import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Breadcrumb, Nav } from 'react-bootstrap';
import './subHeaderstyle.scss';
import { connect } from 'react-redux';
import { onSelectUserViewAction } from '../../../stores/actions/userData';

// import { userChangeAction } from '../../../stores/actions/userData';

class SubHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: localStorage.getItem('FOM_user')
                ? JSON.parse(localStorage.getItem('FOM_user')).userdata.details
                : null,
        };
    }

    navigateToList = () => {
        this.props.setSelectedUser(null);
        this.props.history.push('/model/list');
    };

    render() {
        
        let customerName = '';
        let urlPath = this.props.location.pathname.split('/');

        let modelId = null;
        let userId = null;
        let customerId = null;
        let customerNameRoute = this.props.customerNameRoute;

        //Checking the conditions to show curresponding breadcrumbs
        if (this.props.userData && this.props.userData.modelPayload) {
            customerName = this.props.userData.modelPayload.customerName;
        }

        if (this.props.getSelectedUser && this.props.getSelectedUser.user && this.props.getSelectedUser.user.payload) {
            customerName = this.props.getSelectedUser.user.payload.company;
        }

        if (this.props.match.params && this.props.match.params.modelId) {
            modelId = this.props.match.params.modelId;
        }

        if (this.props.match.params && this.props.match.params.userId) {
            userId = this.props.match.params.userId;
        }

        if (this.props.match.params && this.props.match.params.customerId) {
            customerId = this.props.match.params.customerId;
        }

        const isHomeActive = this.props.location.pathname === '/model/list';

        const showBreadCrumb = (urlPath.findIndex((item) => item === 'create') !== -1 || modelId)  
                                || (urlPath.findIndex((item) => item === 'user') !== -1  || userId)
                                || (urlPath.findIndex((item) => item === 'customer') !== -1  || customerId)

        return (
            <div className="header-sticky">
                <div className="sub-header-main">
                    <Nav className="mr-auto">
                        <div className="breadcrumb-box">

                        {
                            showBreadCrumb &&
                            <Breadcrumb>
                                <Breadcrumb.Item active={isHomeActive} onClick={this.navigateToList}>
                                    Home
                                </Breadcrumb.Item>


                                {urlPath.findIndex((item) => item === 'create') !== -1 || modelId ? (
                                    <> <Breadcrumb.Item active>{customerName}</Breadcrumb.Item>  <Breadcrumb.Item active>Model</Breadcrumb.Item></>
                                   
                                ) : null}


                                {urlPath.findIndex((item) => item === 'create') !== -1 ? (
                                    <Breadcrumb.Item active>Create</Breadcrumb.Item>
                                ) : null}

                                {urlPath.findIndex((item) => item === 'user') !== -1 ? (
                                    userId ? (<>
                                                <Breadcrumb.Item active>{customerNameRoute}</Breadcrumb.Item>
                                                <Breadcrumb.Item active>View User</Breadcrumb.Item>
                                              </>
                                    ) : (
                                        <Breadcrumb.Item active>Add User</Breadcrumb.Item>
                                    )
                                ) : null}

                                {urlPath.findIndex((item) => item === 'customer') !== -1 ? (
                                    customerId ? (<> 
                                                     <Breadcrumb.Item active>{customerNameRoute}</Breadcrumb.Item>
                                                     <Breadcrumb.Item active>View Customer</Breadcrumb.Item>
                                                  </>
                                    ) : (
                                        <Breadcrumb.Item active>Add Customer</Breadcrumb.Item>
                                    )
                                ) : null}

                            </Breadcrumb>
                         }
                        </div>
                    </Nav>
                </div>
            </div>
        );
    }
}

/**
 * Mapping redux state into props
 */
const MapStateToProps = (state) => {
    return {
        userData: state.userChangeAction,
        getSelectedUser: state.getSelectedUser,
    };
};

/**
 * Redux dipatch events method for changing redux state
 */
const MapDispatchToProps = (dispatch) => {
    return {
        setSelectedUser: (params) => dispatch(onSelectUserViewAction(params)),
    };
};

SubHeader.propTypes = {
    history: PropTypes.object.isRequired,
    userData: PropTypes.object,
    match: PropTypes.object.isRequired,
    setSelectedUser: PropTypes.func,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }),
    getSelectedUser: PropTypes.object,
    customerNameRoute:  PropTypes.object,
};

export default connect(MapStateToProps)(withRouter(connect(null, MapDispatchToProps)(SubHeader)));
